module.exports = __webpack_public_path__ + "static/kanban-noestimates-xp-85ebd8fce6d2b99aa10811a6a662426e.png";